import ReactDOM from "react-dom"
import LostBaggageGuideComponent from "./lost-baggage-guide-component"

export default class LostBaggageGuideModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.viewmodelJson && JSON.parse(elem.dataset.viewmodelJson)
    self.airlinesJson = elem.dataset.airlinesJson && JSON.parse(elem.dataset.airlinesJson)
    self.handlingPolicies = elem.dataset.handlingPolicies && JSON.parse(elem.dataset.handlingPolicies)
    this.init()
    return self
  }

  init() {
    const self = this
    console.log(self.modelJson)
    console.log(self.airlinesJson)
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<LostBaggageGuideComponent componentData={self.modelJson} airlines={self.airlinesJson} />, self.elem)
  }
}
